(() => {
  const onReady = (fn) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  };

  onReady(() => {
    document.documentElement.classList.add('js-ready');
    // Reveal anything already in view immediately
    document.querySelectorAll('.sg-in').forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.92) el.classList.add('is-visible');
    });

    const header = document.querySelector('[data-sg-header]');
    if (header) {
      let ticking = false;
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          header.classList.toggle('is-scrolled', window.scrollY > 10);
          ticking = false;
        });
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    const toggle = document.querySelector('[data-sg-menu]');
    const nav = document.querySelector('[data-sg-nav]');
    const scrim = document.querySelector('[data-sg-scrim]');

    // Header section may already bind the menu; skip duplicate handlers
    if (toggle && nav && toggle.dataset.sgBound !== '1') {
      const setMenu = (open) => {
        nav.classList.toggle('is-open', !!open);
        if (scrim) {
          scrim.classList.toggle('is-open', !!open);
          scrim.hidden = !open;
        }
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
        document.body.classList.toggle('sg-menu-open', !!open);
        document.body.style.overflow = open ? 'hidden' : '';
      };

      toggle.dataset.sgBound = '1';
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        setMenu(!nav.classList.contains('is-open'));
      });
      scrim?.addEventListener('click', () => setMenu(false));
      nav.querySelectorAll('a').forEach((a) => a.addEventListener('click', () => setMenu(false)));
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') setMenu(false);
      });
      window.addEventListener('resize', () => {
        if (window.matchMedia('(min-width: 1081px)').matches) setMenu(false);
      });
    }
    const reveals = document.querySelectorAll('.sg-in');
    const revealNow = (el) => el.classList.add('is-visible');
    if (reveals.length && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              revealNow(entry.target);
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.01, rootMargin: '0px 0px 12% 0px' }
      );
      reveals.forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight + 80 && rect.bottom > -40) {
          revealNow(el);
        } else {
          io.observe(el);
        }
      });
    } else {
      reveals.forEach(revealNow);
    }

    document.querySelectorAll('[data-sg-feat-rail]').forEach((rail) => {
      const track = rail.querySelector('[data-sg-feat-track]');
      if (!track) return;

      track.querySelectorAll('[data-sg-feat-clone]').forEach((node) => node.remove());
      delete track.dataset.sgFeatCloned;

      const cards = () => [...track.querySelectorAll('[data-sg-feat-card]')];
      if (cards().length < 2) return;

      const mobile = () => window.matchMedia('(max-width: 820px)').matches;
      const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let raf = 0;
      let paused = false;
      let holding = false;
      let resumeTimer = null;
      let holdTimer = null;
      let last = 0;
      const speed = 48;

      const maxScroll = () => {
        const list = cards();
        const lastCard = list[list.length - 1];
        if (!lastCard) return 0;
        const leftPad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
        return Math.max(0, lastCard.offsetLeft - leftPad);
      };

      const goToStart = () => {
        holding = true;
        track.classList.remove('is-autoplaying');
        track.scrollTo({ left: 0, behavior: 'smooth' });
        window.clearTimeout(holdTimer);
        holdTimer = window.setTimeout(() => {
          holding = false;
          last = 0;
          if (!paused) track.classList.add('is-autoplaying');
        }, 900);
      };

      const tick = (now) => {
        raf = window.requestAnimationFrame(tick);
        if (!mobile() || paused || holding || document.hidden || reduce()) {
          last = now;
          if (!mobile() || paused || holding || reduce()) track.classList.remove('is-autoplaying');
          return;
        }
        track.classList.add('is-autoplaying');
        if (!last) last = now;
        const dt = Math.min(40, now - last);
        last = now;
        const end = maxScroll();
        if (end <= 4) return;

        if (track.scrollLeft >= end - 1.5) {
          track.scrollLeft = end;
          holding = true;
          track.classList.remove('is-autoplaying');
          window.clearTimeout(holdTimer);
          holdTimer = window.setTimeout(goToStart, 1400);
          return;
        }

        track.scrollLeft = Math.min(end, track.scrollLeft + (speed * dt) / 1000);
      };

      const play = () => {
        window.cancelAnimationFrame(raf);
        last = 0;
        if (!mobile() || reduce()) {
          track.classList.remove('is-autoplaying');
          return;
        }
        raf = window.requestAnimationFrame(tick);
      };

      const pause = () => {
        paused = true;
        holding = false;
        track.classList.remove('is-autoplaying');
        window.clearTimeout(resumeTimer);
        window.clearTimeout(holdTimer);
        resumeTimer = window.setTimeout(() => {
          paused = false;
          last = 0;
          play();
        }, 4200);
      };

      track.addEventListener('pointerdown', pause, { passive: true });
      track.addEventListener('touchstart', pause, { passive: true });
      track.addEventListener('wheel', pause, { passive: true });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          window.cancelAnimationFrame(raf);
          window.clearTimeout(holdTimer);
          track.classList.remove('is-autoplaying');
        } else if (!paused) play();
      });

      window.addEventListener('resize', () => {
        window.cancelAnimationFrame(raf);
        window.clearTimeout(holdTimer);
        holding = false;
        play();
      }, { passive: true });

      play();
    });

    document.querySelectorAll('[data-sg-standard]').forEach((root) => {
      const fill = root.querySelector('[data-sg-standard-fill]');
      const items = [...root.querySelectorAll('[data-sg-standard-item]')];
      if (!fill || !items.length) return;
      const setFill = () => {
        const vis = items.filter((el) => el.classList.contains('is-visible')).length;
        fill.style.transform = `scaleX(${vis / items.length})`;
      };
      if (!('IntersectionObserver' in window)) {
        items.forEach((el) => el.classList.add('is-visible'));
        setFill();
        return;
      }
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) entry.target.classList.add('is-visible');
          });
          setFill();
        },
        { threshold: 0.4 }
      );
      items.forEach((el) => io.observe(el));
    });

    document.querySelectorAll('[data-sg-tabs]').forEach((tabs) => {
      const buttons = tabs.querySelectorAll('[data-sg-tab]');
      const panels = tabs.querySelectorAll('[data-sg-panel]');
      buttons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const id = btn.getAttribute('data-sg-tab');
          buttons.forEach((b) => b.classList.toggle('is-active', b === btn));
          panels.forEach((p) => p.classList.toggle('is-active', p.getAttribute('data-sg-panel') === id));
        });
      });
    });

    document.querySelectorAll('[data-sg-qty]').forEach((wrap) => {
      const input = wrap.querySelector('input');
      wrap.querySelector('[data-sg-qty-dec]')?.addEventListener('click', () => {
        input.value = Math.max(1, Number(input.value || 1) - 1);
      });
      wrap.querySelector('[data-sg-qty-inc]')?.addEventListener('click', () => {
        input.value = Math.max(1, Number(input.value || 1) + 1);
      });
    });

    /* Homepage hero slider */
    document.querySelectorAll('[data-sg-hero]').forEach((hero) => {
      const slides = [...hero.querySelectorAll('[data-sg-hero-slide]')];
      const dots = [...hero.querySelectorAll('[data-sg-hero-dot]')];
      if (slides.length < 2) return;
      let index = 0;
      let timer;
      const wait = 3000;

      const go = (next) => {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === index);
          const fill = dot.querySelector('.sg-hero-dot__fill');
          if (fill) {
            fill.style.animation = 'none';
            void fill.offsetWidth;
            fill.style.animation = '';
          }
        });
      };

      const play = () => {
        clearInterval(timer);
        timer = window.setInterval(() => go(index + 1), wait);
      };

      hero.querySelector('[data-sg-hero-prev]')?.addEventListener('click', (e) => {
        e.preventDefault();
        go(index - 1);
        play();
      });
      hero.querySelector('[data-sg-hero-next]')?.addEventListener('click', (e) => {
        e.preventDefault();
        go(index + 1);
        play();
      });
      dots.forEach((dot) => {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          go(Number(dot.getAttribute('data-sg-hero-dot')));
          play();
        });
      });

      let startX = 0;
      hero.addEventListener('touchstart', (e) => {
        startX = e.changedTouches[0].screenX;
      }, { passive: true });
      hero.addEventListener('touchend', (e) => {
        const dx = e.changedTouches[0].screenX - startX;
        if (Math.abs(dx) < 40) return;
        go(index + (dx < 0 ? 1 : -1));
        play();
      }, { passive: true });

      hero.addEventListener('mouseenter', () => clearInterval(timer));
      hero.addEventListener('mouseleave', play);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) clearInterval(timer);
        else play();
      });
      play();
    });

    /* PDP gallery thumbs */
    document.querySelectorAll('[data-sg-pdp]').forEach((pdp) => {
      const stage = pdp.querySelector('[data-sg-stage]');
      const slides = [...pdp.querySelectorAll('[data-sg-slide]')];
      const thumbs = [...pdp.querySelectorAll('[data-sg-thumb]')];
      if (!slides.length || !thumbs.length) return;

      const setSlide = (index) => {
        const i = String(index);
        slides.forEach((s) => {
          const on = s.getAttribute('data-sg-slide') === i;
          s.classList.toggle('is-active', on);
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
        thumbs.forEach((t) => {
          const on = t.getAttribute('data-sg-thumb') === i;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      };

      thumbs.forEach((thumb) => {
        thumb.setAttribute('aria-pressed', thumb.classList.contains('is-active') ? 'true' : 'false');
        thumb.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          setSlide(thumb.getAttribute('data-sg-thumb'));
        });
      });

      // Also allow clicking the stage area to cycle (optional safety)
      if (stage && slides.length > 1) {
        stage.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          const current = slides.findIndex((s) => s.classList.contains('is-active'));
          const next =
            e.key === 'ArrowRight'
              ? (current + 1) % slides.length
              : (current - 1 + slides.length) % slides.length;
          setSlide(next);
        });
      }
    });

    /* Sticky ATC */
    const sticky = document.querySelector('[data-sg-sticky-atc]');
    const addBtn = document.querySelector('[data-sg-add], [data-sg-nn-add]');
    const stickyAdd = document.querySelector('[data-sg-sticky-add]');
    const form = document.querySelector('[data-sg-product-form], [data-sg-nn-form]');
    const buyBox = document.querySelector('[data-sg-pdp] .sg-buy');

    if (sticky && addBtn) {
      sticky.hidden = false;
      const io = new IntersectionObserver(
        ([entry]) => {
          sticky.classList.toggle('is-show', !entry.isIntersecting);
        },
        { threshold: 0, rootMargin: '-20% 0px 0px 0px' }
      );
      io.observe(addBtn);
    } else if (sticky && buyBox && 'IntersectionObserver' in window) {
      const ioSticky = new IntersectionObserver(
        ([entry]) => {
          sticky.hidden = entry.isIntersecting;
        },
        { threshold: 0.15 }
      );
      ioSticky.observe(buyBox);
    }

    stickyAdd?.addEventListener('click', () => {
      const nnAdd = document.querySelector('[data-sg-nn-add]');
      if (nnAdd) {
        nnAdd.click();
        return;
      }
      if (form && !addBtn?.disabled) form.requestSubmit ? form.requestSubmit() : form.submit();
    });

    /* Add to cart micro feedback */
    if (form && addBtn) {
      const label = addBtn.querySelector('[data-sg-add-label]');
      form.addEventListener('submit', () => {
        addBtn.classList.add('is-added');
        if (label) label.textContent = 'Added';
        window.setTimeout(() => {
          addBtn.classList.remove('is-added');
          if (label && !addBtn.disabled) label.textContent = 'Add to cart';
        }, 1600);
      });
    }

    /* Accordion: one open at a time */
    document.querySelectorAll('[data-sg-faq]').forEach((faq) => {
      faq.querySelectorAll('details').forEach((detail) => {
        detail.addEventListener('toggle', () => {
          if (!detail.open) return;
          faq.querySelectorAll('details').forEach((other) => {
            if (other !== detail) other.open = false;
          });
        });
      });
    });

    /* Announcement bar rotate — smooth crossfade */
    document.querySelectorAll('[data-sg-announce]').forEach((bar) => {
      const items = [...bar.querySelectorAll('[data-sg-announce-item]')];
      if (items.length < 2) return;
      let i = 0;
      let busy = false;
      const go = (next) => {
        if (busy) return;
        busy = true;
        const current = items[i];
        const upcoming = items[next];
        current.classList.add('is-leave');
        current.classList.remove('is-active');
        upcoming.classList.add('is-active');
        upcoming.classList.remove('is-leave');
        window.setTimeout(() => {
          current.classList.remove('is-leave');
          i = next;
          busy = false;
        }, 560);
      };
      window.setInterval(() => go((i + 1) % items.length), 2800);
    });
  });
})();
